

import AllCoinsHeader from '../AllCoinsHeader';
import AllCoinMain from '../AllCoinMain';

const AllCoins = () => {
    return (
        <section className="all-coins">
            <AllCoinsHeader/>
            <AllCoinMain/>
        </section>
    );
}
 
export default AllCoins;